import { DomainStatus, Downtime } from "./types";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: Downtime = {
  current: undefined,
  loading: false,
  error: "",
};

const DowntimeSlice = createSlice({
  name: "downtime",
  initialState,
  reducers: {
    fetchDowntimeStart: (state) => {
      state.loading = true;
    },

    fetchDowntimeSucceeded: (state, action: PayloadAction<DomainStatus>) => {
      const { payload } = action;

      state.current = payload;
      state.error = "";
      state.loading = false;
    },

    fetchDowntimeFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { actions } = DowntimeSlice;
export const {
  fetchDowntimeStart,
  fetchDowntimeSucceeded,
  fetchDowntimeFailed,
} = actions;
export default DowntimeSlice.reducer;
